export const TRACKTOR_API_DA_TYPE = "DIGITAL_AGENDA";
export const TRACKTOR_API_SGPS_TYPE = "SGPS_IMPORT";
